import { EndpointEnum } from '../../constants/EndpointEnum';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import IStore from '../../models/IStore';
import * as EffectUtility from '../../utilities/EffectUtility';
import * as HttpUtility from '../../utilities/HttpUtility';
import  { FileDownloadModel, FilePathModel } from '../models/FileServiceModel';

export default class FileServiceEffect {

	private static readonly DATA_PREFIX = '/data';
	
	public static async getFiles(state: IStore, navigationPath?: string): Promise<FilePathModel[] | HttpErrorResponseModel> {
		
		const nav = navigationPath 
					? `${FileServiceEffect.DATA_PREFIX}${navigationPath}` 
					: FileServiceEffect.DATA_PREFIX;
		return EffectUtility.getToModel<FilePathModel[]>(
			state,
			FilePathModel,
			`${EndpointEnum.fileservice}?navigationPath=${nav}`
		);
	}

	public static async getFileData(state: IStore, filePath: string): Promise<FileDownloadModel | HttpErrorResponseModel> {
		const fileToDownload = `${FileServiceEffect.DATA_PREFIX}${filePath}`;
		const response = await HttpUtility.get(
			state,
			EndpointEnum.fileDownload,
			{ filePath: fileToDownload },
			{ responseType: 'blob' }
		);
		if (response instanceof HttpErrorResponseModel) return response;

		return new FileDownloadModel({
			content: response.data as Blob,
			fileName: FileServiceEffect.getFileNameFromResponseHeaders(response.headers?.['content-disposition']),
		});
	}

	public static async downloadFiles(state: IStore, prefix: string): Promise<FileDownloadModel | HttpErrorResponseModel> {
		const filesToDownload = `${FileServiceEffect.DATA_PREFIX}${prefix}`;
		const response = await HttpUtility.get(
			state,
			EndpointEnum.fileDownloadFiles,
			{ prefix: filesToDownload },
			{ responseType: 'blob' }
		);
		if (response instanceof HttpErrorResponseModel) return response;

		return new FileDownloadModel({
			content: response.data as Blob,
			fileName: FileServiceEffect.getFileNameFromResponseHeaders(response.headers?.['content-disposition']),
		});
	}

	private static getFileNameFromResponseHeaders(contentDisposition?: string): string | undefined {
		if (!contentDisposition) {
			return undefined;
		}

		const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
		if (utf8Match?.[1]) {
			try {
				return decodeURIComponent(utf8Match[1]);
			} catch {
				return utf8Match[1];
			}
		}

		const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
		return filenameMatch?.[1];
	}
}

